import { Override } from '../common';
import { IUser, IUserPhoneSchema } from '../user';

export enum ESiteType {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
}

export interface IPage {
  pageType: 'CardCSP';
  siteType: ESiteType;
}

interface IUserExtra {
  uxfb_country_projects?: 'justCard';
}

export interface ITrackingUser {
  balance?: number;
  email?: string;
  userId?: number;
  cianUserId?: number;
  extra?: IUserExtra;
}

export interface IProduct {
  id: number;
  dealType: 'sale';
  objectType: 'CSP';
  name: string;
  position: number;
}

export interface IPageViewObject {
  products: IProduct[];
  page: IPage;
  user: ITrackingUser;
}

export type TAuthenticatedUser = Override<
  IUser,
  {
    balance: number;
    email?: string;
    userId: number;
    id: number;
    phones?: IUserPhoneSchema[];
  }
>;

export type TPhoneOpenAction =
  | 'Open_CSP_card_floating_block'
  | 'Open_CSP_card_blockDeveloper'
  | 'Open_CSP_card_popupMore'
  | 'Open_CSP_card_projectGallery';
